import * as managers from './list'

import type { Manager } from 'app/types/park/manager'

export const allManagers: Manager[] = Object.values(managers).sort(
    (previous, current) => previous.name.localeCompare(current.name),
)
